const INDUSTRIES_API_REQUEST = "INDUSTRIES/INDUSTRIES_API_REQUEST";
const INDUSTRIES_API_SUCCESS = "INDUSTRIES/INDUSTRIES_API_SUCCESS";
const INDUSTRIES_API_FAILED = "INDUSTRIES/INDUSTRIES_API_FAILED";

export { INDUSTRIES_API_REQUEST, INDUSTRIES_API_SUCCESS, INDUSTRIES_API_FAILED }